import { render } from "./NotificationConfig.vue?vue&type=template&id=213cbb18&scoped=true"
import script from "./NotificationConfig.vue?vue&type=script&lang=js"
export * from "./NotificationConfig.vue?vue&type=script&lang=js"

import "./NotificationConfig.vue?vue&type=style&index=0&id=213cbb18&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213cbb18"]])

export default __exports__